"use client";

import dynamic from "next/dynamic";

// Shared client-side async boundary for the Ashtakoot milan studio (its graph
// carries ashtakoot-milan-data plus the studio compute/share stack, measured
// duplicated across the en and hi kundli-matching routes, 2026-08-22). Static
// imports from the two server pages gave each route chunk group a full copy;
// this ONE client module puts the studio in a single async chunk both routes
// load. Default ssr keeps the studio's crawlable SSR HTML intact.
const AshtakootMilanStudioLazy = dynamic(() => import("./AshtakootMilanStudio"));

export default AshtakootMilanStudioLazy;
